
<div id="SGPBNew" [style.display]="!isHistorySection ? 'block' : 'none'">
  <header>
    <nav class="navbar px-2">

      <div class="d-flex justify-content-start align-items-center mt-0">
        <h6 class="text-nowrap my-1 me-2 fw-bold" for="dateperiod">{{sectionname}}</h6>
        <select class="form-select form-select-sm" id="dateperiod" [(ngModel)]="selectedGP" (change)="OnChangeGradingPeriod($event);" [disabled]="!isStaffUser" required>
          <option *ngFor="let gpo of gradingperiodobj" value={{gpo.schoolTermGradingPeriodId}}>{{gpo.gradingPeriod}}</option>
        </select>
      </div>
      <div class="mt-0">
        <ul class="navbar-nav flex-grow">
          <li class="nav-item" *ngIf="isStaffUser">
            <a class="btn btn-outline-dark" *ngIf="!loading" (click)="redirectHistory()">History</a>
          </li>
        </ul>

      </div>

    </nav>
  </header>

  <p-messages [(value)]="msgs1" [enableService]="false"></p-messages>
  <p-messages [(value)]="msgs2" [enableService]="false"></p-messages>
  <p-messages [(value)]="msgs3" [enableService]="false"></p-messages>
  <p-messages [(value)]="msgs4" [enableService]="false"></p-messages>
  <p-messages [(value)]="msgs5" [enableService]="false"></p-messages>
  <p-toast></p-toast>

  <p-confirmDialog key="confDialog" position="top" [style]="{width: '30rem'}" closable="false" />

  <div class="row mx-0">
    <div class="col-12 px-0">
      <p-table #dt [value]="studentsdata" [(selection)]="selectedStudents" dataKey="school_uid"
               [globalFilterFields]="['studentFullName','school_uid']"
               [autoLayout]="true" [loading]="loading"
               sortField="studentFullNameWithoutSpace"
               (onRowExpand)="onRowExpand($event)" (onRowCollapse)="onRowCollapse()" [expandedRowKeys]="expandedRows">

        <ng-template pTemplate="caption">
          <div class="table-actions d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-0">
            <div class="actions-left d-flex align-items-center">
              <!-- <button type="button" class="btn btn-outline-dark" (click)="expandFilterRow()" style="display: none">
                <i class="fas fa-filter"></i>
                <span *ngIf="showFilterRow">Hide </span>
                <span *ngIf="!showFilterRow">Show </span>
                Filters
              </button> -->
              <div class="d-flex align-items-center header-chart">
                <!--<p-chart type="horizontalBar" [data]="gradeCountChart" [options]="gradeCountOptions" height="38px" class="ms-3" [style.display]="!loading ? 'inline-block' : 'none'"></p-chart>-->
                <div class="d-inline-block ml-0">Student Grade Distribution:</div>
                <span [class]="'badge ms-2 lettergrade-'+(grade.key).toLowerCase()" *ngFor="let grade of gradeCounts | keyvalue">
                  {{grade.key}}: {{grade.value}}
                </span>
              </div>
            </div>
            <div class="actions-right btn-toolbar mb-2 mb-md-0">
              <div class="input-action input-group ms-2">

                <input type="text" pInputText (input)="filterTable($event)" #searchInput class="form-control rounded" placeholder="Search...">

                <button type="button" id="search-clear" class="btn bg-transparent" (click)="clearGlobalSearch()">
                  <fa-icon [icon]="faTimes"></fa-icon>
                </button>
              </div>
              <button type="button" class="btn btn-outline-dark ms-2" *ngIf="editFlag && SelectedGPIndex != 0"
                      (click)="expandAll()" pTooltip="{{!isExpanded ? 'Expand' : 'Collapse'}} All" tooltipPosition="top">
                <fa-icon [icon]="faExpandAlt" *ngIf="!isExpanded"></fa-icon>
                <fa-icon [icon]="faCompressAlt" *ngIf="isExpanded"></fa-icon>
              </button>
              <button *ngIf="isStaffUser" type="button" class="btn btn-outline-dark ms-2" (click)="CreatePdfNew()" pTooltip="Print to PDF" tooltipPosition="top" [disabled]="!isPdfEnabled">
                <fa-icon [icon]="faPrint"></fa-icon>
              </button>

              <button *ngIf="isStaffUser" type="button" class="btn btn-outline-dark d-none ms-2" (click)="CreatePdfNew(true)" pTooltip="PDF Preview" tooltipPosition="top" [disabled]="!isPdfEnabled">
                <fa-icon [icon]="faPrint"></fa-icon>
              </button>
              <!--<a pTooltip="Print to PDF Test" tooltipPosition="top" href="http://localhost:57122/studentgrade/generatepdf?data=studentsdata"> <fa-icon [icon]="faPrint"></fa-icon></a>-->
              <!--<button type="button" class="btn btn-outline-dark ms-2" pTooltip="Print to PDF Test" tooltipPosition="top" (click)="getpdf()">
                <fa-icon [icon]="faPrint"></fa-icon>
              </button>-->
              <button type="button" class="btn btn-outline-dark ms-2" pTooltip="Support" tooltipPosition="top" (click)="onNavigateHelp()">
                <fa-icon [icon]="faQuestionCircle"></fa-icon>
              </button>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr [style.display]="!loading ? 'table-row' : 'none'">
            <th [ngStyle]="{
              width: editFlag ? '2.5rem' : '0',
              textAlign: 'center'
            }">
              <p-tableHeaderCheckbox *ngIf="editFlag" />
            </th>
            <th #sourceTh class="student-name" pSortableColumn="studentFullNameWithoutSpace">Student Name <p-sortIcon field="studentFullNameWithoutSpace"></p-sortIcon></th>
            <th #sourceTh class="gradebook-grade" pSortableColumn="grade">Grade<br /> Book <p-sortIcon field="grade"></p-sortIcon></th>
            <th #sourceTh class="grade-override text-nowrap form-horizontal">

              <div class="form-group">
                <label for="inputState">Grade Book Override</label>
                <!--<app-grading-scale></app-grading-scale>-->
                <p-dropdown [options]="gradingscales" [(ngModel)]="selectedGradeOverride" placeholder="{{selectedStudents?.length > 0 ? 'Apply to Selected' : 'Apply to all'}}"
                            optionLabel="letterGrade" optionValue="gradingScaleID"
                            (onChange)="gradeOverride($event)" appendTo="body"
                            [showClear]="false" [filter]="false" *ngIf="editFlag">
                  <ng-template let-cm pTemplate="selectedItem">
                    <div class="gradeoverride-item-selected gradeoverride-item-value" *ngIf="selectedGradeOverride">
                      <div>{{cm.letterGrade}}</div>
                    </div>
                  </ng-template>
                  <ng-template let-cm pTemplate="item">
                    <div class="gradeoverride-item">
                      <div>{{cm.letterGrade}}</div>
                    </div>
                  </ng-template>
                </p-dropdown>

              </div>

            </th>
            <th #sourceTh class="work-habits">

              <div class="form-group">
                <label for="inputState">Work Habits</label>

                <p-dropdown [options]="workhabitcodes" [(ngModel)]="selectedWorkHabitOverride" placeholder="{{selectedStudents?.length > 0 ? 'Apply to Selected' : 'Apply to all'}}"
                            optionLabel="workHabitCode" optionValue="workHabitCode"
                            (onChange)="workHabitOverride($event)" appendTo="body"
                            [showClear]="false" [filter]="false" *ngIf="editFlag">
                  <ng-template let-cm pTemplate="selectedItem">
                    <div class="workhabitoverride-item-selected workhabitoverride-item-value" *ngIf="selectedWorkHabitOverride">
                      <div>{{cm.workHabitCode}}</div>
                    </div>
                  </ng-template>
                  <ng-template let-cm pTemplate="item">
                    <div class="workhabitoverride-item">
                      <div>{{cm.workHabitCode}}</div>
                    </div>
                  </ng-template>
                </p-dropdown>

              </div>

            </th>
            <th #sourceTh class="cooperation">

              <div class="form-group">
                <label for="inputState">Cooperation</label>

                <p-dropdown [options]="citizenshipcodes" [(ngModel)]="selectedCoopOverride" placeholder="{{selectedStudents?.length > 0 ? 'Apply to Selected' : 'Apply to all'}}"
                            (onChange)="citizenOverride($event)" appendTo="body"
                            optionLabel="description" optionValue="citizenshipCode" [showClear]="false" [filter]="false" *ngIf="editFlag">
                  <ng-template let-cm pTemplate="selectedItem">
                    <div class="coopoverride-item-selected coopoverride-item-value" *ngIf="selectedCoopOverride">
                      <div>{{cm.citizenshipCode}} </div>
                    </div>
                  </ng-template>
                  <ng-template let-cm pTemplate="item">
                    <div class="coopoverride-item">
                      <div>{{cm.citizenshipCode}} </div>
                    </div>
                  </ng-template>
                </p-dropdown>

              </div>

            </th>
            <!--<th #sourceTh class="comments">
              <a (click)="showCommentDialog()" class="modal-launch" role="button">Comments</a>
              <button pButton type="button" (click)="cmop.toggle($event)" [label]="selectedStudents?.length > 0 ? 'Apply to Selected' : 'Apply to all'"
                      class="p-button-sm p-button-outlined p-button-secondary d-flex" *ngIf="editFlag"></button>


              <p-overlayPanel #cmop [dismissable]="true" [showCloseIcon]="false" [style]="{width: '300px', background:'#2a323d'}" [appendTo]="'body'">
                <ng-template pTemplate>

                  <div class="p-field py-3">
                    <div class="p-float-label">
                      <p-dropdown inputId="bulkCommentChoice" [autoDisplayFirst]="false" [options]="gradescomments" [(ngModel)]="selectedComment"
                                  optionValue="comment_code" optionLabel="label" [filter]="true" filterBy="label"
                                  [showClear]="true" placeholder="" styleClass="comment-bulk">
                        <ng-template let-cm pTemplate="selectedItem">
                          <div class="comment-item-selected comment-item-value" *ngIf="selectedComment">
                            <div>{{cm.label}}</div>
                          </div>
                        </ng-template>
                        <ng-template let-cm pTemplate="item">
                          <div class="comment-item">
                            <div>{{cm.label}}</div>
                          </div>
                        </ng-template>
                      </p-dropdown>
                      <label for="bulkCommentChoice">Select a Comment</label>
                    </div>
                  </div>

                  <div class="p-field py-3">
                    <div class="p-float-label">
                      <p-dropdown inputId="bulkCommentPosition" [autoDisplayFirst]="false" [options]="bulkCommentPositions" [(ngModel)]="selectedCommentPosition"
                                  optionValue="value" optionLabel="name" [filter]="false"
                                  [showClear]="true" placeholder="" styleClass="comment-bulk d-flex">
                        <ng-template let-cm pTemplate="selectedItem">
                          <div class="comment-item-selected comment-item-value">
                            <div>{{cm.name}}</div>
                          </div>
                        </ng-template>
                        <ng-template let-cm pTemplate="item">
                          <div class="comment-item">
                            <div>{{cm.name}}</div>
                          </div>
                        </ng-template>
                      </p-dropdown>
                      <label for="bulkCommentPosition">Select a Comment Position</label>
                    </div>
                  </div>

                  <div class="d-flex justify-content-between align-items-center">
                    <button pButton type="button" (click)="cmop.hide()" label="Cancel" class="p-button-sm p-button-outlined p-button-secondary"></button>
                    <button pButton type="button" [disabled]="!selectedCommentPosition || !selectedComment" [label]="selectedStudents?.length > 0 ? 'Apply to Selected' : 'Apply to all'" (click)="commentOverride()" class="p-button-sm p-button-primary"></button>
                  </div>

                </ng-template>
              </p-overlayPanel>
            </th>

            <th></th>-->

            <th #sourceTh colspan="2" class="comments w-25">
              <a (click)="showCommentDialog()" class="modal-launch" role="button">Comments</a>
              <button pButton type="button" (click)="cmop.toggle($event)" [label]="selectedStudents?.length > 0 ? 'Apply to Selected' : 'Apply to all'"
                      class="p-button-sm p-button-outlined p-button-secondary d-flex" *ngIf="editFlag"></button>


              <p-overlayPanel #cmop [dismissable]="true" [showCloseIcon]="false" [style]="{width: '300px', background:'#2a323d'}" [appendTo]="'body'">
                <ng-template pTemplate>

                  <div class="p-field py-3">
                    <div class="p-float-label">
                      <p-dropdown inputId="bulkCommentChoice" [autoDisplayFirst]="false" [options]="gradescomments" [(ngModel)]="selectedComment"
                                  optionValue="comment_code" optionLabel="label" [filter]="true" filterBy="label"
                                  [showClear]="true" placeholder="" styleClass="comment-bulk">
                        <ng-template let-cm pTemplate="selectedItem">
                          <div class="comment-item-selected comment-item-value" *ngIf="selectedComment">
                            <div>{{cm.label}}</div>
                          </div>
                        </ng-template>
                        <ng-template let-cm pTemplate="item">
                          <div class="comment-item">
                            <div>{{cm.label}}</div>
                          </div>
                        </ng-template>
                      </p-dropdown>
                      <label for="bulkCommentChoice">Select a Comment</label>
                    </div>
                  </div>

                  <div class="p-field py-3">
                    <div class="p-float-label">
                      <p-dropdown inputId="bulkCommentPosition" [autoDisplayFirst]="false" [options]="bulkCommentPositions" [(ngModel)]="selectedCommentPosition"
                                  optionValue="value" optionLabel="name" [filter]="false"
                                  [showClear]="true" placeholder="" styleClass="comment-bulk d-flex">
                        <ng-template let-cm pTemplate="selectedItem">
                          <div class="comment-item-selected comment-item-value">
                            <div>{{cm.name}}</div>
                          </div>
                        </ng-template>
                        <ng-template let-cm pTemplate="item">
                          <div class="comment-item">
                            <div>{{cm.name}}</div>
                          </div>
                        </ng-template>
                      </p-dropdown>
                      <label for="bulkCommentPosition">Select a Comment Position</label>
                    </div>
                  </div>

                  <div class="d-flex justify-content-between align-items-center">
                    <button pButton type="button" (click)="cmop.hide()" label="Cancel" class="p-button-sm p-button-outlined p-button-secondary"></button>
                    <button pButton type="button" [disabled]="!selectedCommentPosition || !selectedComment" [label]="selectedStudents?.length > 0 ? 'Apply to Selected' : 'Apply to all'" (click)="commentOverride()" class="p-button-sm p-button-primary"></button>
                  </div>

                </ng-template>
              </p-overlayPanel>
            </th>

            <th #sourceTh class="receptive-skills" [style.display]="IsOptelEnable && isOptelApplicableSchools ? 'revert' : 'none'">

              <div class="form-group">
                <label for="inputState">Receptive Skills</label>
                <!--    [disabled]="!(editFlag && IsOptelEnable)"-->
                <p-dropdown [options]="receptiveskillscodes" [(ngModel)]="selectedReceptiveSkillsOverride" placeholder="{{selectedStudents?.length > 0 ? 'Apply to Selected' : 'Apply to all'}}"
                            optionLabel="optelSkillsCode" optionValue="optelSkillsCode" 
                            (onChange)="ReceptiveSkillsOverride($event)"
                            [showClear]="false" [filter]="false" *ngIf="editFlag && IsOptelEnable">
                  <ng-template let-cm pTemplate="selectedItem">
                    <div class="workhabitoverride-item-selected workhabitoverride-item-value" *ngIf="selectedReceptiveSkillsOverride">
                      <div>{{cm.optelSkillsCode}}</div>
                    </div>
                  </ng-template>
                  <ng-template let-cm pTemplate="item">
                    <div class="workhabitoverride-item">
                      <div>{{cm.optelSkillsCode}}</div>
                    </div>
                  </ng-template>
                </p-dropdown>

              </div>

            </th>
            <th #sourceTh class="expressive-skills" [style.display]="IsOptelEnable && isOptelApplicableSchools ? 'revert' : 'none'">

              <div class="form-group">
                <label for="inputState">Expressive Skills</label>

                <p-dropdown [options]="expressiveskillscodes" [(ngModel)]="selectedExpressiveSkillsOverride" placeholder="{{selectedStudents?.length > 0 ? 'Apply to Selected' : 'Apply to all'}}"
                            optionLabel="optelSkillsCode" optionValue="optelSkillsCode"
                            (onChange)="ExpressiveSkillsOverride($event)"
                            [showClear]="false" [filter]="false" *ngIf="editFlag && IsOptelEnable">
                  <ng-template let-cm pTemplate="selectedItem">
                    <div class="workhabitoverride-item-selected workhabitoverride-item-value" *ngIf="selectedExpressiveSkillsOverride">
                      <div>{{cm.optelSkillsCode}}</div>
                    </div>
                  </ng-template>
                  <ng-template let-cm pTemplate="item">
                    <div class="workhabitoverride-item">
                      <div>{{cm.optelSkillsCode}}</div>
                    </div>
                  </ng-template>
                </p-dropdown>

              </div>

            </th>
            <!--<th></th>-->

            <th class="text-end" *ngIf="editFlag" pSortableColumn="currentState">Status<br /> <p-sortIcon field="currentState"></p-sortIcon></th>
          </tr>

        </ng-template>

        <ng-template pTemplate="body" let-student let-index let-expanded="expanded">

          <tr class="main-level bg-white" [ngClass]="student.currentState" *ngIf="student.status">
            <td class="select-checkbox">
              <p-tableCheckbox [value]="student" *ngIf="student.objStudentProgram?.[SelectedGPIndex].editFlag" />
            </td>
            <td class="student-name">
              <ng-container *ngIf="student.objStudentProgram?.[SelectedGPIndex].editFlag && SelectedGPIndex != 0; else notExpandable">
                <a href="#" (click)="$event.preventDefault()" class="d-inline-block text-decoration-none text-primary"
                   [pRowToggler]="student">
                  <span>
                    {{student.studentLastName}}, <br />
                    {{student.studentFirstName}} {{student.studentMiddleName}}
                  </span> <br />
                  <span class="text-secondary text-dec">{{student.school_uid}}</span>
                  <i class="pi" [ngClass]="expanded ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                </a>
              </ng-container>

              <ng-template #notExpandable>
                <div class="d-inline-block text-decoration-none text-body">
                  <span>
                    {{student.studentLastName}}, <br />
                    {{student.studentFirstName}} {{student.studentMiddleName}}
                  </span> <br />
                  <span class="text-secondary text-dec">{{student.school_uid}}</span>
                </div>
              </ng-template>
            </td>
            <td class="gradebook-grade align-middle" [ngStyle]="{'width': student.objStudentProgram?.[SelectedGPIndex].editFlag ? '2.5rem' : 'auto'}">
              {{student.gradeletter || 'N/A'}}
            </td>
            <td class="grade-override" *ngIf="student.objStudentProgram?.[SelectedGPIndex].editFlag">
              <p-dropdown [options]="gradingscales" [(ngModel)]="student.objStudentProgram[SelectedGPIndex].postGradingScaleID"
                          optionValue="gradingScaleID" optionLabel="letterGrade" placeholder="Select..." styleClass="grade-scale" name="postGradingScaleID"
                          [showClear]="true" autoDisplayFirst="false" (onChange)="onChangeTracking($event,index, 0)" appendTo="body"
                          [required]="student.objStudentProgram[SelectedGPIndex].isValidationFailed">
              </p-dropdown>
              <small id="last-gradebook-0" class="d-inline-block form-text pending-change">
                <span class="text-nowrap">Last Published:</span>{{student.objStudentProgram[SelectedGPIndex].letterGrade || 'N/A'}}
              </small>
            </td>
            <td class="grade-override-readmode align-middle" *ngIf="!student.objStudentProgram?.[SelectedGPIndex].editFlag">
              {{student.objStudentProgram[SelectedGPIndex].letterGrade || 'N/A'}}
            </td>

            <td class="work-habits" *ngIf="student.objStudentProgram?.[SelectedGPIndex].editFlag">
              <p-dropdown [options]="workhabitcodes" [(ngModel)]="student.objStudentProgram[SelectedGPIndex].postWorkHabitCode"
                          optionValue="workHabitCode" optionLabel="workHabitCode" appendTo="body" placeholder="Select..." styleClass="work-habit"
                          [showClear]="true" (onChange)="onChangeTracking($event,index, 0)">
              </p-dropdown>
              <small id="last-gradebook-0" class="d-inline-block form-text pending-change">
                <span class="text-nowrap">Last Published:</span> {{student.objStudentProgram[SelectedGPIndex].workHabitCode || 'N/A'}}
              </small>
            </td>
            <td class="work-habits-readmode align-middle" *ngIf="!student.objStudentProgram?.[SelectedGPIndex].editFlag">
              {{student.objStudentProgram[SelectedGPIndex].workHabitCode || 'N/A'}}
            </td>

            <td class="cooperation" *ngIf="student.objStudentProgram?.[SelectedGPIndex].editFlag">
              <p-dropdown [options]="citizenshipcodes" [(ngModel)]="student.objStudentProgram[SelectedGPIndex].postCitizenshipCode" *ngIf="student.objStudentProgram?.[SelectedGPIndex].editFlag"
                          optionValue="citizenshipCode" optionLabel="citizenshipCode" appendTo="body" placeholder="Select..." styleClass="citizenship-ship"
                          [showClear]="true" (onChange)="onChangeTracking($event,index, 0)">
                <ng-template pTemplate="selectedItem">
                  <div class="citizenship-ship-item-selected citizenship-ship-item-value" *ngIf="student.objStudentProgram[SelectedGPIndex].postCitizenshipCode">
                    <div>{{student.objStudentProgram[SelectedGPIndex].postCitizenshipCode}}</div>
                  </div>
                </ng-template>
                <ng-template let-cc pTemplate="item">
                  <div class="citizenship-ship-item">
                    <div>{{cc.citizenshipCode}}</div>
                  </div>
                </ng-template>
              </p-dropdown>
              <small id="last-gradebook-0" class="d-inline-block form-text pending-change">
                <span class="text-nowrap" *ngIf="student.objStudentProgram?.[SelectedGPIndex].editFlag">Last Published:</span> {{student.objStudentProgram[SelectedGPIndex].citizenshipCode || 'N/A'}}
              </small>
            </td>

            <td class="cooperation-readmode align-middle" *ngIf="!student.objStudentProgram?.[SelectedGPIndex].editFlag">
              {{student.objStudentProgram[SelectedGPIndex].citizenshipCode || 'N/A'}}
            </td>

            <!--<td class="comments" colspan="2" *ngIf="student.objStudentProgram?.[SelectedGPIndex].editFlag">
              <table class="table table-sm mb-0">
                <tr>
                  <td class="p-0 align-middle">
                    <p-dropdown [options]="gradescomments" [(ngModel)]="student.objStudentProgram[SelectedGPIndex].postComment1"
                                optionValue="comment_code" optionLabel="label" [filter]="true" filterBy="label" name="postComment1"
                                [showClear]="true" placeholder="Select a Comment" [styleClass]="comment-dropdown" (onChange)="onChangeTracking($event,index, 1)"
                                [required]="student.objStudentProgram[SelectedGPIndex].isCommentRequired">
                    </p-dropdown>

                  </td>
                  <td class="align-middle">
                    <small id="last-gradebook-0" class="form-text pending-change">
                      <span class="text-nowrap">Last Published:</span> {{student.objStudentProgram[SelectedGPIndex].comment1 || 'N/A'}}
                    </small>
                  </td>
                </tr>
                <tr>
                  <td class="p-0 align-middle">
                    <p-dropdown [options]="gradescomments" [(ngModel)]="student.objStudentProgram[SelectedGPIndex].postComment2"
                                optionValue="comment_code" optionLabel="label" [filter]="true" filterBy="label" name="postComment2"
                                [showClear]="true" placeholder="Select a Comment" styleClass="comment-dropdown" (onChange)="onChangeTracking($event,index, 2)">
                    </p-dropdown>
                  </td>
                  <td class="align-middle">
                    <small id="last-gradebook-0" class="form-text pending-change">
                      <span class="text-nowrap">Last Published:</span> {{student.objStudentProgram[SelectedGPIndex].comment2 || 'N/A'}}
                    </small>
                  </td>
                </tr>
                <tr>
                  <td class="p-0 align-middle">
                    <p-dropdown [options]="gradescomments" [(ngModel)]="student.objStudentProgram[SelectedGPIndex].postComment3"
                                optionValue="comment_code" optionLabel="label" [filter]="true" filterBy="label" name="postComment3"
                                [showClear]="true" placeholder="Select a Comment" styleClass="comment-dropdown" (onChange)="onChangeTracking($event,index, 3)">
                    </p-dropdown>
                  </td>
                  <td class="align-middle">
                    <small id="last-gradebook-0" class="form-text pending-change">
                      <span class="text-nowrap">Last Published:</span> {{student.objStudentProgram[SelectedGPIndex].comment3 || 'N/A'}}
                    </small>
                  </td>
                </tr>


              </table>
            </td>
            <td colspan="2" *ngIf="!student.objStudentProgram?.[SelectedGPIndex].editFlag">
              <ol>
                <li> {{student.objStudentProgram[SelectedGPIndex].comment1}} {{student.objStudentProgram[SelectedGPIndex].comment1Tooltip || 'N/A'}} </li>
                <li> {{student.objStudentProgram[SelectedGPIndex].comment2}} {{student.objStudentProgram[SelectedGPIndex].comment2Tooltip || 'N/A'}} </li>
                <li> {{student.objStudentProgram[SelectedGPIndex].comment3}} {{student.objStudentProgram[SelectedGPIndex].comment3Tooltip || 'N/A'}} </li>
              </ol>
            </td>-->



            <td class="comments" colspan="2" *ngIf="student.objStudentProgram?.[SelectedGPIndex].editFlag">
              <table class="table table-sm mb-0">
                <tr>
                  <td class="p-0 align-middle">
                    <p-dropdown [options]="gradescomments" [(ngModel)]="student.objStudentProgram[SelectedGPIndex].postComment1"
                                optionValue="comment_code" optionLabel="label" [filter]="true" filterBy="label" name="postComment1"
                                [showClear]="true" placeholder="Select a Comment" appendTo="body" styleClass="comment-dropdown" (onChange)="onChangeTracking($event,index, 1)"
                                [required]="student.objStudentProgram[SelectedGPIndex].isCommentRequired">
                    </p-dropdown>

                  </td>
                  <td class="align-middle py-0">
                    <small id="last-gradebook-0" class="d-inline-block form-text pending-change form-text">
                      <span class="text-nowrap">Last Published:</span> {{student.objStudentProgram[SelectedGPIndex].comment1 || 'N/A'}}
                    </small>
                  </td>
                </tr>
                <tr>
                  <td class="p-0 align-middle">
                    <p-dropdown [options]="gradescomments" [(ngModel)]="student.objStudentProgram[SelectedGPIndex].postComment2"
                                optionValue="comment_code" optionLabel="label" [filter]="true" filterBy="label" name="postComment2"
                                [showClear]="true" placeholder="Select a Comment" appendTo="body" styleClass="comment-dropdown" (onChange)="onChangeTracking($event,index, 2)">
                    </p-dropdown>
                  </td>
                  <td class="align-middle py-0">
                    <small id="last-gradebook-0" class="d-inline-block form-text pending-change form-text">
                      <span class="text-nowrap">Last Published:</span> {{student.objStudentProgram[SelectedGPIndex].comment2 || 'N/A'}}
                    </small>
                  </td>
                </tr>
                <tr>
                  <td class="p-0 align-middle">
                    <p-dropdown [options]="gradescomments" [(ngModel)]="student.objStudentProgram[SelectedGPIndex].postComment3"
                                optionValue="comment_code" optionLabel="label" [filter]="true" filterBy="label" name="postComment3"
                                [showClear]="true" placeholder="Select a Comment" appendTo="body" styleClass="comment-dropdown" (onChange)="onChangeTracking($event,index, 3)">
                    </p-dropdown>
                  </td>
                  <td class="align-middle py-0">
                    <small id="last-gradebook-0" class="d-inline-block form-text pending-change form-text">
                      <span class="text-nowrap">Last Published:</span> {{student.objStudentProgram[SelectedGPIndex].comment3 || 'N/A'}}
                    </small>
                  </td>
                </tr>


              </table>
            </td>
            <td class="receptive-skills" [style.display]="IsOptelEnable && isOptelApplicableSchools ? 'revert' : 'none'"
                *ngIf="student.objStudentProgram?.[SelectedGPIndex].editFlag"
                [ngClass]="{'bg-light': !student.objStudentProgram[SelectedGPIndex].isOptelApplicable}">
              <small class="d-block text-nowrap" [ngStyle]="{'opacity': student.objStudentProgram[SelectedGPIndex].isOptelApplicable ? '1' : '0.5'}">(Listening and Reading)</small>
              <p-dropdown [options]="receptiveskillscodes" appendTo="body"
                          [disabled]="!student.objStudentProgram[SelectedGPIndex].isOptelApplicable"
                          [(ngModel)]="student.objStudentProgram[SelectedGPIndex].postReceptiveSkills"
                          optionValue="optelSkillsCode" optionLabel="optelSkillsCode" placeholder="Select..." styleClass="receptive-skills"
                          [showClear]="true" (onChange)="onChangeTracking($event,index, 0)">
              </p-dropdown>
              <small id="last-gradebook-0" class="d-inline-block form-text pending-change" [ngStyle]="{'opacity': student.objStudentProgram[SelectedGPIndex].isOptelApplicable ? '1' : '0.5'}">
                <span class="text-nowrap">Last Published:</span> {{student.objStudentProgram[SelectedGPIndex].receptiveSkills || 'N/A' | levelExtract}}
              </small>
            </td>
            <td colspan="2" *ngIf="!student.objStudentProgram?.[SelectedGPIndex].editFlag">
              <ol>
                <li> {{student.objStudentProgram[SelectedGPIndex].comment1}} {{student.objStudentProgram[SelectedGPIndex].comment1Tooltip || 'N/A'}} </li>
                <li> {{student.objStudentProgram[SelectedGPIndex].comment2}} {{student.objStudentProgram[SelectedGPIndex].comment2Tooltip || 'N/A'}} </li>
                <li> {{student.objStudentProgram[SelectedGPIndex].comment3}} {{student.objStudentProgram[SelectedGPIndex].comment3Tooltip || 'N/A'}} </li>
              </ol>
            </td>
            <td class="work-habits-readmode align-middle" [style.display]="IsOptelEnable && isOptelApplicableSchools ? 'revert' : 'none'" *ngIf="!(student.objStudentProgram?.[SelectedGPIndex].editFlag) && IsOptelEnable">
              {{student.objStudentProgram[SelectedGPIndex].receptiveSkills || 'N/A'}}
            </td>
            <!--[disabled]="!(student.objStudentProgram[SelectedGPIndex].isOptelApplicable && IsOptelEnable)"-->
            <td class="expressive-skills"
                [style.display]="IsOptelEnable && isOptelApplicableSchools ? 'revert' : 'none'"
                *ngIf="student.objStudentProgram?.[SelectedGPIndex].editFlag"
                [ngClass]="{'bg-light': !student.objStudentProgram[SelectedGPIndex].isOptelApplicable}">
              <small class="d-block text-nowrap" [ngStyle]="{'opacity': student.objStudentProgram[SelectedGPIndex].isOptelApplicable ? '1' : '0.5'}">(Speaking and Writing)</small>
              <p-dropdown appendTo="body" [options]="expressiveskillscodes" [(ngModel)]="student.objStudentProgram[SelectedGPIndex].postExpressiveSkills"
                          [disabled]="!student.objStudentProgram[SelectedGPIndex].isOptelApplicable"
                          optionValue="optelSkillsCode" optionLabel="optelSkillsCode" placeholder="Select..." styleClass="expressive-skills"
                          [showClear]="true" (onChange)="onChangeTracking($event,index, 0)">
              </p-dropdown>
              <small id="last-gradebook-0" class="d-inline-block form-text pending-change" [ngStyle]="{'opacity': student.objStudentProgram[SelectedGPIndex].isOptelApplicable ? '1' : '0.5'}">
                <span class="text-nowrap">Last Published:</span> {{student.objStudentProgram[SelectedGPIndex].expressiveSkills || 'N/A' | levelExtract}}
              </small>
            </td>
            <td class="work-habits-readmode align-middle" [style.display]="IsOptelEnable && isOptelApplicableSchools ? 'revert' : 'none'" *ngIf="!(student.objStudentProgram?.[SelectedGPIndex].editFlag) && IsOptelEnable">
              {{student.objStudentProgram[SelectedGPIndex].expressiveSkills || 'N/A'}}
            </td>
            <td class="status" *ngIf="student.objStudentProgram?.[SelectedGPIndex].editFlag">
              &nbsp;
            </td>

          </tr>

          <tr *ngIf="student.status && student.objStudentProgram[SelectedGPIndex].isValidationFailed">
            <td colspan="11" class="alert alert-danger rounded-0">
              <div class="col-lg-10 text-center">
                {{student.objStudentProgram[SelectedGPIndex].ValidationMessage}}
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="rowexpansion" let-student>
          <!-- <tr class="child-level"> -->
          <!-- <td colspan="8">
            <div class="p-0">
              <p-table [value]="student.objPastStudentProgram" dataKey="studentCode" styleClass="p-datatable-sm">
                <ng-template pTemplate="header"> -->
          <tr class="spacer">
            <td colspan="11"></td>
          </tr>
          <tr class="child-level-header">
            <th class="student-name" colspan="3">
              Previous Grading Periods
            </th>
            <th class="grade-override">
              Grade
            </th>
            <th class="work-habits">
              Work Habits
            </th>
            <th class="cooperation">
              Cooperation
            </th>
            <th class="comments">
              Comments
            </th>
            <th class="attendance">
              Attendance
            </th>
            <th class="receptive-skills">
             <!-- Receptive Skills-->
            </th>
            <th class="expressive-skills">
             <!-- Expressive Skills-->
            </th>
            <th class="status"></th>
          </tr>
          <!-- </ng-template>
          <ng-template pTemplate="body" let-sp> -->
          <tr class="child-level-data" *ngFor="let sp of student.objPastStudentProgram">
            <td colspan="3">{{sp.gradingPeriodFullName}}</td>
            <td colspan="1">
              {{sp.letterGrade}}
              <i class="pi" [ngClass]="sp.gradingScalePrevCompare" pTooltip="Compared to previous grading period" tooltipPosition="top"></i>
            </td>
            <td>
              {{sp.workHabitCode}}
              <i class="pi" [ngClass]="sp.workHabitPrevCompare" pTooltip="Compared to previous grading period" tooltipPosition="top"></i>
            </td>
            <td>
              {{sp.citizenshipCode}}
              <i class="pi" [ngClass]="sp.citizenshipPrevCompare" pTooltip="Compared to previous grading period" tooltipPosition="top"></i>
            </td>
            <td class="text-nowrap">
              <span class="badge badge-secondary me-2" pTooltip={{sp.comment1Tooltip}}>{{sp.comment1 || 'N/A'}}</span>
              <span class="badge badge-secondary me-2" pTooltip={{sp.comment2Tooltip}}>{{sp.comment2 || 'N/A'}}</span>
              <span class="badge badge-secondary me-2" pTooltip={{sp.comment3Tooltip}}>{{sp.comment3 || 'N/A'}}</span>
            </td>
            <td class="text-nowrap attendance">
              <!--<p-chart #attendanceChart [data]="stackedData" [options]="stackedOptions"></p-chart>-->
              <span class="badge lettergrade-a me-2" pTooltip="Present" tooltipPosition="top">{{sp.present}}</span>
              <span class="badge lettergrade-c me-2" pTooltip="Tardy" tooltipPosition="top">{{sp.tardy}}</span>
              <span class="badge lettergrade-f me-2" pTooltip="Absent" tooltipPosition="top">{{sp.absent}}</span>
            </td>
            <td>
              <!--{{sp.receptiveSkills}}
              <i class="pi" [ngClass]="sp.ReceptiveSkillsPrevCompare" pTooltip="Compared to previous grading period" tooltipPosition="top"></i>-->
            </td>
            <td>
              <!--{{sp.expressiveSkills}}
              <i class="pi" [ngClass]="sp.ExpressiveSkillsPrevCompare" pTooltip="Compared to previous grading period" tooltipPosition="top"></i>-->
            </td>
            <td></td>
          </tr>
          <tr class="spacer">
            <td colspan="11"></td>
          </tr>
          <!-- </ng-template>
              </p-table>
            </div>
          </td> -->
          <!-- </tr> -->
        </ng-template>

        <ng-template pTemplate="summary">

          <div class="col-12 d-flex justify-content-between mb-5">
            <div class="" *ngIf="TotalStudentRecords > 0 ? true : false">
              In total, there are {{TotalStudentRecords}} students.
            </div>
            <div *ngIf="editFlag">
              <span *ngIf="isValidationFailed" style="font-weight:bold; color:red;">Validation Errors exist. See above</span> &nbsp;&nbsp;
              <button *ngIf="!isReadOnlyMode" type="button" class="btn btn-primary btn-lg text-uppercase"
                      (click)="PostData(studentsdata)" [disabled]="!isDirty">



                Publish <!--{{selectedStudents?.length > 0 ? selectedStudents?.length : ''}}-->


              </button> 
            </div> 
          </div> 
          <div> 
            <footer class="my-5 pt-5 text-muted text-center text-small" style="display: block">
              <p class="mb-1"> Personalized Learning Systems </p>
              <p class="mb-1"> &copy; 2021 Los Angeles Unified School District</p>
            </footer>
          </div>
        </ng-template>

      </p-table>

      <p-dialog header="Comments" [(visible)]="commentDialog" modal="true">
        <div>
          <table class="table">
            <tr>
              <th>Code</th>
              <th>Description</th>
            </tr>
            <tr *ngFor="let cm of gradescomments">
              <td>{{cm.comment_type_id}}</td>
              <td>{{cm.comment}}</td>
            </tr>
          </table>
        </div>
      </p-dialog>

      <p-toast position="top-center" key="c" (onClose)="onReject()" [baseZIndex]="5000">
        <ng-template let-message pTemplate="message">
          <div class="p-flex p-flex-column" style="flex: 1">
            <div class="p-text-center">
              <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
              <h4>{{message.summary}}</h4>
              <p>{{message.detail}}</p>
            </div>
            <div class="row">
              <div class="col-6">
                <button type="button" pButton (click)="onConfirm()" label="Refresh" class="p-button-success"></button>
              </div>
            </div>
          </div>
        </ng-template>
      </p-toast>

    </div>
  </div>
</div>
<div id="SGPBHistoryNew" [style.display]="isHistorySection ? 'block' : 'none'">
  <header>
    <nav class="navbar px-0">
      <div class="ms-2">
        <ul class="navbar-nav flex-grow">
          <li class="nav-item">
            <a class="btn btn-outline-dark" (click)="redirectHome()">Back</a>
          </li>
        </ul>

      </div>

      <div class="">
        <label class="my-1 me-2 fw-bold" for="dateperiod">Select Grading Period</label>
        <select class="custom-select my-1 mr-sm-2" id="dateperiod" [(ngModel)]="historyselectedGP" (change)="OnChangeHistoryGradingPeriod();" required>
          <option *ngFor="let gpo of histroygradingperiodobj" value={{gpo.schoolTermGradingPeriodId}}>{{gpo.gradingPeriod}}</option>
        </select>
      </div>

    </nav>
  </header>

  <div class="row">
    <div class="col-12">
      <p-table #dth [value]="statusLogdata" dataKey="processId" [loading]="loading"
               [autoLayout]="true" sortField="syncTime" [sortOrder]="-1"
               [expandedRowKeys]="expandedRowsHistory" (onRowExpand)="onHistoryRowExpand($event)">

        <ng-template pTemplate="header">
          <tr [style.display]="!loading ? 'table-row' : 'none'">

            <th style="width: auto">Submission Status</th>
            <th style="width: auto">Published Time</th>
            <th style="width: auto">Total Submissions</th>
            <th style="width: auto">Successful</th>
            <th style="width: auto">Failed</th>
            <th style="width: auto">Failure Percent</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-log let-expanded="expanded">

          <tr class="main-level bg-white" [ngClass]="'state-success'">

            <td>
              <i class="pi me-2" [ngClass]="log.failedStudentCount > 0 ? 'pi-times-circle text-danger' : 'pi-check-square text-success'"></i>
              <a href="#" class="" [pRowToggler]="log">
                {{log.submissionStatus}}
                <i class="pi" [ngClass]="expanded ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
              </a>
            </td>
            <td>{{log.syncTime | date:"medium" }} - {{log.syncTime | dateAgo}}</td>
            <td>{{log.totalStudentCount }}</td>
            <td>{{log.successStudentCount }}</td>
            <td>{{log.failedStudentCount }}</td>
            <td>{{log.totalStudentCount > 0 ? log.failurePercent : 0}}%</td>

          </tr>
        </ng-template>


        <ng-template pTemplate="rowexpansion" let-log>

          <tr class="child-level history-log-child">
            <td colspan="8">
              <div class="p-0">
                <table class="table table-sm">
                  <tr>
                    <td style="background-color: transparent">
                      <div *ngIf="log.failedStudentCount > 0"><span style="font-size: medium; font-weight: bold;">Failed Submissions</span> &nbsp; <i class="pi me-2" [ngClass]="'pi-times-circle text-danger'"></i></div>
                      <div *ngFor="let lg of log.lstLogStudentDetails" class="d-inline-block pr-1">
                        <span class="badge badge-secondary mb-1" [style.display]="lg.responseCode !== '200' ? 'inline-block' : 'none'">
                          {{lg.studentName}}
                        </span>
                      </div>
                    </td>
                    <td style="background-color: transparent">
                      <div *ngIf="log.successStudentCount > 0"><span style="font-size:medium; font-weight:bold;">Successful Submissions</span> &nbsp;<i class="pi me-2" [ngClass]="'pi-check-square text-success'"></i></div>
                      <div *ngFor="let lg of log.lstLogStudentDetails" class="d-inline-block pr-1">
                        <span class="badge badge-secondary mb-1" [style.display]="lg.responseCode == '200' ? 'inline-block' : 'none'">
                          {{lg.studentName}}
                        </span>
                      </div>
                    </td>
                  </tr>
                </table>

              </div>
            </td>
          </tr>
        </ng-template>

      </p-table>
    </div>
  </div>
  <div>
    <footer class="my-5 pt-5 text-muted text-center text-small" style="display: block">
      <p class="mb-1"> Personalized Learning Systems </p>
      <p class="mb-1"> &copy; 2021 Los Angeles Unified School District</p>
    </footer>
  </div>
